import {
  ref,
  onMounted,
  defineComponent,
  reactive,
  computed,
} from "@vue/composition-api";
// import { formatTotal } from "@/utilities/display-helpers";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import ListPageHeader from "@/components/ListPageHeader/ListPageHeader.vue";

// import { inventoryLotsController } from "@/controllers/inventoryLots";
import { commodityInventorySummariesController } from "@/controllers/commodityInventorySummaries";
import { CommodityInventorySummary } from "@/models/CommodityInventorySummary";
import { delayController, DelayReturnStatus } from "@/controllers/delay";

import { JSConn } from "@/utilities/js-conn";
import { itemRouteBuilder, NamedRts } from "@/router";

export default defineComponent({
  name: "commodityInventorySummaries",
  components: {
    LoadingAnimation,
    ListPageHeader,
  },

  setup(_props, ctx) {
    const $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage =
      "Please wait while the summaries for the commodities are loaded...";

    const showMenu = ref(false);

    const localCommodityInventorySummaries = computed(() => {
      return $store.getters
        .commodityInventorySummaries as CommodityInventorySummary[];
    });

    const showRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.commodityInventorySummaryShow, id);
    };

    onMounted(() => {
      const jsConn = new JSConn();

      Promise.all([
        commodityInventorySummariesController.needCommodityInventorySummaries(
          jsConn,
        ),
      ]).finally(() => {
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,
      // formatTotal,

      localCommodityInventorySummaries,

      showRouteBuilder,

      showMenu,
    };
  },
});
